import { jsxs as d } from "react/jsx-runtime";
import { useId as b } from "@rmwc/base";
import { FormField as g } from "@rmwc/formfield";
function x(e) {
  const { className: l, style: r, rootProps: t, label: c, children: a, disabled: n } = e, i = e.label || e.children, o = b("toggle-", e), m = (s) => i ? /* @__PURE__ */ d(g, { ...t, className: l, style: r, children: [
    s,
    /* @__PURE__ */ d("label", { id: o + "label", htmlFor: o, children: [
      c,
      a
    ] })
  ] }) : s, u = i ? { disabled: n } : {
    className: l,
    style: r,
    disabled: n,
    ...t
  };
  return {
    id: o,
    renderToggle: m,
    toggleRootProps: u
  };
}
export {
  x as useToggleFoundation
};
